import PropTypes from 'prop-types';
import React from 'react';
import { styled } from 'linaria/react';
import t from '@jetshop/intl';

const StockStatus = styled('div')`
  color: black;

  font-size: 10pt;
  font-weight: 300;
  padding: 0.5em 0;
`;

const StockStatusIndicator = ({ status, text }) => {
  return (
    <StockStatus>
      {(status === 'inStock', parseFloat(text) < 1) && (
        <p>{t('Out of stock')}</p>
      )}
      {(status === 'inStock', parseFloat(text) > 1, parseFloat(text) <= 10) && (
        <p>{t('Few in stock')}</p>
      )}
      {(status === 'inStock', parseFloat(text) > 10) && <p>{t('In stock')}</p>}
    </StockStatus>
  );
};

StockStatusIndicator.propTypes = {
  status: PropTypes.oneOf(['inStock', 'outOfStock', 'notifyWhenBack']),
  text: PropTypes.string
};

export default StockStatusIndicator;
